import React, { FC, useId, HTMLAttributes } from 'react';

export const DefaqtoStars: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const id = useId();

  return (
    <div {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 96 60"
        aria-describedby={id}
      >
        <title id={id}>Defaqto - Expert Rated 5-Stars</title>
        <path
          fill="#fff"
          fillOpacity="1"
          stroke="none"
          fillRule="nonzero"
          d="M0 2.484A2.482 2.482 0 0 1 2.48 0h91.04A2.482 2.482 0 0 1 96 2.484v55.032A2.482 2.482 0 0 1 93.52 60H2.48A2.482 2.482 0 0 1 0 57.516Zm0 0"
        />
        <path
          fill="#000"
          fillOpacity="1"
          stroke="none"
          fillRule="evenodd"
          d="M93.52.871H2.48c-.89 0-1.613.723-1.613 1.613v55.032c0 .89.723 1.613 1.613 1.613h91.04c.89 0 1.613-.723 1.613-1.613V2.484c0-.89-.723-1.613-1.613-1.613ZM2.48 0A2.482 2.482 0 0 0 0 2.484v55.032A2.482 2.482 0 0 0 2.48 60h91.04A2.482 2.482 0 0 0 96 57.516V2.484A2.482 2.482 0 0 0 93.52 0Zm0 0"
        />
        <path
          fill="#ee7203"
          fillOpacity="1"
          stroke="none"
          fillRule="nonzero"
          d="M11.598 45.156H6.14l4.402 3.23-1.738 5.528 4.527-3.418 4.652 3.418-1.797-5.527 4.403-3.23h-5.52l-1.738-5.282ZM28.898 45.156h-5.457l4.403 3.23-1.735 5.528 4.528-3.418 4.648 3.418-1.797-5.527 4.403-3.23h-5.52l-1.734-5.282ZM46.262 45.156h-5.457l4.406 3.23-1.738 5.528L48 50.496l4.652 3.418-1.8-5.527 4.402-3.23h-5.516L48 39.874ZM63.629 45.156h-5.457l4.402 3.23-1.738 5.528 4.527-3.418 4.653 3.418-1.797-5.527 4.402-3.23h-5.52l-1.738-5.282ZM80.992 45.156h-5.457l4.403 3.23-1.735 5.528 4.527-3.418 4.649 3.418-1.797-5.527 4.402-3.23h-5.52l-1.734-5.282Zm0 0"
        />
        <path
          fill="#13130a"
          fillOpacity="1"
          stroke="none"
          fillRule="evenodd"
          d="M26.441 5.16h-1.086v4.457h-.03c-.919-1.336-2.38-1.676-3.313-1.676-2.782 0-4.57 2.172-4.57 4.438 0 2.437 1.894 4.473 4.57 4.473.902 0 2.41-.34 3.312-1.692h.031v1.492h1.086Zm-7.914 7.266c0-2.156 1.618-3.508 3.485-3.508 1.96 0 3.406 1.629 3.406 3.492 0 1.988-1.57 3.465-3.406 3.465-2.086 0-3.485-1.555-3.485-3.45M36.938 12.8c.042-.823-.079-1.773-.653-2.687a4.429 4.429 0 0 0-3.797-2.172c-2.472.047-4.414 2.063-4.414 4.47 0 2.405 2.055 4.44 4.43 4.44 1.96 0 3.594-1.285 4.184-2.98h-1.153c-.387 1.059-1.488 1.973-3.043 2.004-1.668 0-3.219-1.414-3.297-3.074Zm-7.743-.98c.309-2 1.973-2.902 3.309-2.902a3.39 3.39 0 0 1 3.328 2.902Zm0 0"
        />
        <path
          fill="#13130a"
          fillOpacity="1"
          stroke="none"
          fillRule="evenodd"
          d="M39.207 16.648h1.09V9.137h2.18v-.98h-2.18c0-.794-.031-2.188 2.18-2.188V4.957c-3.145.035-3.239 2.02-3.27 3.2h-1.32v.98h1.32Zm0 0"
        />
        <path
          fill="#13130a"
          fillOpacity="1"
          stroke="none"
          fillRule="evenodd"
          d="M52.125 8.156h-1.086v1.492h-.031c-.899-1.414-2.39-1.71-3.309-1.71-2.785 0-4.574 2.175-4.574 4.44 0 2.438 1.898 4.474 4.574 4.474.887 0 2.375-.297 3.309-1.692h.031v1.492h1.086Zm-7.91 4.27c0-2.156 1.617-3.508 3.484-3.508 1.864 0 3.403 1.629 3.403 3.492 0 1.988-1.567 3.465-3.403 3.465-2.086 0-3.484-1.555-3.484-3.45M62.672 8.156h-1.09v1.492h-.031c-.903-1.398-2.395-1.71-3.313-1.71-2.781 0-4.57 2.175-4.57 4.44 0 2.438 1.898 4.474 4.57 4.474.887 0 2.395-.297 3.313-1.692h.031v4.469h1.09Zm-7.914 4.27c0-2.156 1.617-3.508 3.48-3.508 1.961 0 3.407 1.629 3.407 3.492 0 1.988-1.57 3.465-3.407 3.465-2.082 0-3.48-1.555-3.48-3.45"
        />
        <path
          fill="#13130a"
          fillOpacity="1"
          stroke="none"
          fillRule="nonzero"
          d="M65.7 16.648h1.09V9.137h2.038v-.98H66.79V5.16H65.7v2.996h-1.785v.98H65.7Zm0 0"
        />
        <path
          fill="#13130a"
          fillOpacity="1"
          stroke="none"
          fillRule="evenodd"
          d="M69.617 12.457c0 2.3 1.945 4.395 4.434 4.395 2.488 0 4.46-2.141 4.46-4.457 0-2.313-1.945-4.454-4.46-4.454a4.484 4.484 0 0 0-4.434 4.516m1.09-.016c0-2.25 1.8-3.523 3.36-3.523 1.46 0 3.359 1.195 3.359 3.43 0 2.238-1.715 3.527-3.36 3.527-1.757 0-3.359-1.46-3.359-3.434"
        />
        <path
          fill="#13130a"
          fillOpacity="1"
          stroke="none"
          fillRule="nonzero"
          d="M0 22.855h96v14.536H0Zm0 0"
        />
        <path
          fill="#fff"
          fillOpacity="1"
          stroke="none"
          fillRule="nonzero"
          d="M18.266 33.54h-4.008v-7.095h4.008v.98h-2.848v1.927h2.672v.976h-2.672v2.227h2.848ZM25.027 33.54h-1.324l-1.781-2.907-1.793 2.906h-1.246l2.355-3.676-2.195-3.418h1.285l1.645 2.688 1.64-2.688h1.242l-2.203 3.45ZM28.04 26.445c.913 0 1.581.188 2 .563.42.375.632.902.632 1.578 0 .309-.05.602-.149.879-.093.273-.246.52-.464.73-.215.211-.5.38-.856.5-.351.125-.789.188-1.305.188h-.753v2.656H25.98v-7.094Zm-.08.965h-.815v2.5h.632c.368 0 .676-.043.93-.125.258-.09.45-.226.582-.414.133-.187.2-.433.2-.742 0-.41-.126-.715-.372-.918-.246-.2-.633-.3-1.156-.3ZM36.098 33.54h-4.012v-7.095h4.012v.98h-2.852v1.927h2.672v.976h-2.672v2.227h2.852ZM39.621 26.445c.61 0 1.113.075 1.508.223.402.148.7.375.894.68.196.304.293.691.293 1.16 0 .351-.062.648-.191.894s-.3.45-.508.61c-.21.164-.437.293-.676.39l2.012 3.137h-1.312l-1.711-2.844h-1.14v2.844h-1.161v-7.094Zm-.078.973h-.754v2.316h.805c.539 0 .93-.097 1.172-.3.246-.2.37-.497.37-.887 0-.41-.132-.703-.394-.875-.258-.168-.656-.254-1.199-.254ZM46.422 33.54h-1.168v-6.102H43.18v-.993h5.312v.992h-2.07ZM54.145 26.445c.609 0 1.113.075 1.511.223.399.148.7.375.89.68.2.304.298.691.298 1.16 0 .351-.067.648-.196.894-.128.246-.296.45-.507.61-.211.164-.434.293-.672.39l2.008 3.137h-1.313l-1.71-2.844h-1.138v2.844h-1.164v-7.094Zm-.079.973h-.75v2.316h.805c.54 0 .93-.097 1.172-.3.246-.2.367-.497.367-.887 0-.41-.129-.703-.39-.875-.258-.168-.66-.254-1.204-.254ZM62.879 33.54l-.691-1.97H59.48l-.695 1.97H57.56l2.636-7.122h1.29l2.632 7.121Zm-.992-2.97-.672-1.941a25.104 25.104 0 0 1-.113-.352c-.047-.156-.098-.312-.145-.472-.05-.16-.09-.297-.121-.407-.031.133-.074.282-.121.446-.047.16-.09.312-.137.457-.043.14-.074.25-.098.328l-.675 1.941ZM67.508 33.54H66.34v-6.102h-2.074v-.993h5.308v.992h-2.066ZM74.672 33.54H70.66v-7.095h4.012v.98h-2.848v1.927h2.668v.976h-2.668v2.227h2.848ZM81.953 29.926c0 .797-.148 1.465-.445 2.004a2.83 2.83 0 0 1-1.293 1.207c-.567.27-1.246.402-2.043.402h-1.969v-7.094h2.18c.734 0 1.367.133 1.898.399.535.261.946.652 1.239 1.168.289.515.433 1.152.433 1.914Zm-1.21.035c0-.586-.09-1.063-.274-1.438a1.797 1.797 0 0 0-.805-.835c-.352-.184-.789-.278-1.305-.278h-.992v5.156h.824c.856 0 1.493-.218 1.918-.656.422-.437.633-1.086.633-1.95Zm0 0"
        />
      </svg>
    </div>
  );
};
